import { useEffect, useState } from "react";
import { Filter, X } from "lucide-react";
import { fetchProducts } from "../lib/api";

export default function OrderFilters({ value, onChange, count, totalArs }) {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    fetchProducts().then((d) => setProducts(Object.values(d.products || {}).flat())).catch(() => {});
  }, []);
  const set = (k, v) => onChange({ ...value, [k]: v });
  const active = value.date_from || value.date_to || value.package_id;
  const input = "px-3 py-2 rounded-md bg-black border border-white/10 text-white text-sm [color-scheme:dark]";
  return (
    <div className="mb-4 rounded-lg border border-white/10 bg-[#0d0d0d] p-3 flex flex-wrap items-end gap-3" data-testid="order-filters">
      <Filter className="w-4 h-4 text-[#ff4500] mb-2.5" />
      <label className="text-[10px] uppercase tracking-widest text-neutral-500">
        Desde
        <input type="date" lang="es-AR" value={value.date_from} onChange={(e) => set("date_from", e.target.value)} data-testid="filter-date-from" className={`block mt-1 ${input}`} />
      </label>
      <label className="text-[10px] uppercase tracking-widest text-neutral-500">
        Hasta
        <input type="date" lang="es-AR" value={value.date_to} onChange={(e) => set("date_to", e.target.value)} data-testid="filter-date-to" className={`block mt-1 ${input}`} />
      </label>
      <label className="text-[10px] uppercase tracking-widest text-neutral-500 min-w-0">
        Paquete
        <select value={value.package_id} onChange={(e) => set("package_id", e.target.value)} data-testid="filter-package" className={`block mt-1 max-w-[220px] ${input}`}>
          <option value="">Todos</option>
          {products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          <option value="reseller_topup">Carga de saldo revendedor</option>
        </select>
      </label>
      {active && (
        <button onClick={() => onChange({ date_from: "", date_to: "", package_id: "" })} data-testid="filter-clear" className="mb-0.5 px-3 py-2 rounded-md bg-white/5 hover:bg-white/10 text-xs flex items-center gap-1 text-white">
          <X className="w-3.5 h-3.5" /> Limpiar
        </button>
      )}
      <div className="ml-auto text-xs text-neutral-400 mb-2" data-testid="filter-summary">
        {count} pedidos{totalArs != null ? ` · ${new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS", maximumFractionDigits: 0 }).format(totalArs)}` : ""}
      </div>
    </div>
  );
}
